export const checkUsernameValidation = (username: string) => {
  let errorMessage = '';

  if (!username) {
    errorMessage = '이름을 입력해주세요.';
  } else if (username.includes(' ')) {
    errorMessage = '이름에 공백을 넣을 수 없습니다.';
  } else if (username.length < 2) {
    errorMessage = '이름은 2자 이상 입력해주세요.';
  } else if (username.length > 20) {
    errorMessage = '이름은 20자 이하로 입력해주세요.';
  } else if (!/^[a-zA-Z가-힣_-]+$/.test(username)) {
    errorMessage = '이름은 한글, 영문만 사용할 수 있습니다.';
  }

  return { isValid: !errorMessage, errorMessage };
};

export const checkEmailValidation = (email: string) => {
  let errorMessage = '';
  if (!email) {
    errorMessage = '이메일 주소를 입력해주세요.';
  } else if (email.includes(' ')) {
    errorMessage = '이메일 주소에 공백을 넣을 수 없습니다.';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errorMessage = '올바른 이메일 주소를 입력해주세요.';
  }

  return { isValid: !errorMessage, errorMessage };
};

export const checkPasswordValidation = (password: string) => {
  let errorMessage = '';

  if (!password) {
    errorMessage = '비밀번호를 입력해주세요.';
  } else if (password.includes(' ')) {
    errorMessage = '비밀번호에 공백을 넣을 수 없습니다.';
  } else if (password.length < 6) {
    errorMessage = '비밀번호는 6자 이상 입력해주세요.';
  } else if (password.length > 250) {
    errorMessage = '비밀번호는 250자 이하로 입력해주세요.';
  }

  return { isValid: !errorMessage, errorMessage };
};

export const checkPasswordConfirmValidation = (confirmPassword: string, password: unknown) => {
  let errorMessage = '';
  if (!confirmPassword) {
    errorMessage = '비밀번호 확인을 입력해주세요.';
  } else if (password !== confirmPassword) {
    errorMessage = '비밀번호가 일치하지 않습니다.';
  }

  return { isValid: !errorMessage, errorMessage };
};

export const checkPhoneNumberValidation = (phoneNumber: string) => {
  let errorMessage = '';

  if (!phoneNumber) {
    errorMessage = '휴대폰 번호를 입력해주세요.';
  } else if (phoneNumber.includes(' ')) {
    errorMessage = '휴대폰 번호에 공백을 넣을 수 없습니다.';
  } else {
    // 숫자만 추출
    const numbersOnly = phoneNumber.replace(/[^0-9]/g, '');

    if (numbersOnly.length < 10) {
      errorMessage = '올바른 휴대폰 번호를 입력해주세요.';
    } else if (numbersOnly.length > 11) {
      errorMessage = '휴대폰 번호가 너무 깁니다.';
    } else if (!/^(01[016789])/.test(numbersOnly)) {
      errorMessage = '올바른 휴대폰 번호 형식이 아닙니다.';
    } else if (numbersOnly.length === 10 && !/^(01[016789])[0-9]{7}$/.test(numbersOnly)) {
      errorMessage = '올바른 휴대폰 번호를 입력해주세요.';
    } else if (numbersOnly.length === 11 && !/^(01[016789])[0-9]{8}$/.test(numbersOnly)) {
      errorMessage = '올바른 휴대폰 번호를 입력해주세요.';
    }
  }

  return { isValid: !errorMessage, errorMessage };
};
